
import { Component, Vue, Prop } from 'vue-property-decorator'
import { CardClient } from '@/api'
import _ from 'lodash'
import BaseEditor from '@/views/BaseEditor'

@Component({
  name: 'CardReplacement',
  components: {

  }
})
export default class extends BaseEditor {
  private async checkFromCard(rule:any, value:any, callback:any) {
    const cardClient = this.client as CardClient
    const cardFrom = await cardClient.getByCardNumber(value)

    if (cardFrom) {
      if (cardFrom.state === '正常') {
        return callback(new Error('正常状态的卡片不允许补卡'))
      } else if (cardFrom.state === '作废') {
        return callback(new Error('作废状态的卡片不允许补卡'))
      } else {
        this.data.balance = cardFrom.account_balance
        return callback()
      }
    } else {
      return callback(new Error('卡片不存在'))
    }
  }

  private async checkToCard(rule:any, value:any, callback:any) {
    const cardClient = this.client as CardClient
    const cardTo = await cardClient.getByCardNumber(value)
    if (cardTo) {
      if (cardTo.state === '挂失') {
        return callback(new Error('挂失状态的卡片不允许作为转移卡'))
      } else if (cardTo.state === '作废') {
        return callback(new Error('作废状态的卡片不允许作为转移卡'))
      } else {
        return callback()
      }
    } else {
      return callback(new Error('卡片不存在'))
    }
  }
  public constructor() {
    super()
    this.client = new CardClient()
    this.data = {}
    this.rules = {
      to: [{ required: true, validator: this.checkToCard, trigger: 'blur' }],
      from: [{ required: true, validator: this.checkFromCard, trigger: 'blur' }]
    }
  }

  public async getData(id = -1) {
    await super.getData(id)
  }

  public async reset() {
    this.data = {
      from: null,
      balance: null,
      to: null
    }
  }

  protected generateData(): any {
    const data = _.pick(this.data, [
      'from',
      'balance',
      'to'
    ])
    return this.clearData(data)
  }

  private async replacement() {
    const form = this.$refs['dataForm'] as any
    const cardClient = this.client as CardClient
    form.validate((valid:Boolean) => {
      if (valid) {
        this.listLoading = true
        this.$confirm('您确定要将卡片：' + this.data.from + '作废，并将余额转移至' + this.data.to + '卡中吗？该操作无法撤销！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async() => {
          const tempData = Object.assign({}, this.data)
          delete tempData.balance
          try {
            await cardClient.replacement(tempData)
            await this.reset()
            this.$notify({
              title: '成功',
              message: '补卡成功，您可以在卡片动态中查看相关记录',
              type: 'success',
              duration: 2000
            })
            this.listLoading = false
          } catch (e) {
            this.listLoading = false
            this.$notify({
              title: '失败',
              message: e.message(),
              type: 'error',
              duration: 2000
            })
          }
        }).catch(() => {
          this.listLoading = false
        })
      } else {
        return false
      }
    })
  }
}
